import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const ChairliftDB = () => {
  const [usersData] = useState({
    data: [
      {
        _id: "user12345",
        name: "Alice Johnson",
        email: "alice.johnson@example.com",
        role: "Admin",
        isActive: true,
      },
      {
        _id: "user67890",
        name: "Bob Smith",
        email: "bob.smith@example.com",
        role: "User",
        isActive: false,
      },
      {
        _id: "user54321",
        name: "Charlie Davis",
        email: "charlie.davis@example.com",
        role: "Moderator",
        isActive: true,
      },
      {
        _id: "user98765",
        name: "Diana Prince",
        email: "diana.prince@example.com",
        role: "Supervisor",
        isActive: true,
      },
    ],
  });

  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 3;

  const filteredUsers = usersData.data.filter((user) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      user.name.toLowerCase().includes(lowerSearch) ||
      user.email.toLowerCase().includes(lowerSearch) ||
      (user.isActive ? "active" : "inactive").includes(lowerSearch)
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginatedUsers = filteredUsers.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <div className="col-12">
      <div className="card">
        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title m-0">Form</h4>
          <div className="d-flex align-items-center gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search by name, email or status"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(0);
              }}
            />
            <button
              className="btn btn-secondary btn-md"
              style={{ whiteSpace: "nowrap" }}
            >
              Add
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedUsers.length > 0 ? (
                  paginatedUsers.map((user, i) => (
                    <tr key={i}>
                      <td>{currentPage * itemsPerPage + i + 1}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        <span
                          className={`badge light ${
                            user.isActive ? "badge-success" : "badge-danger"
                          }`}
                        >
                          <i
                            className={`fa fa-circle me-1 ${
                              user.isActive ? "text-success" : "text-danger"
                            }`}
                          />
                          {user.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>{user.role}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle variant="link">
                            &#x2022;&#x2022;&#x2022;
                          </Dropdown.Toggle>
                          <Dropdown.Menu align="end">
                            <Dropdown.Item>Edit User</Dropdown.Item>
                            <Dropdown.Item>Delete User</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing{" "}
              {filteredUsers.length === 0
                ? 0
                : currentPage * itemsPerPage + 1}{" "}
              to{" "}
              {Math.min(
                (currentPage + 1) * itemsPerPage,
                filteredUsers.length
              )}{" "}
              of {filteredUsers.length} entries
            </div>
            <div>
              <Link
                className={`btn btn-sm btn-outline-primary me-2 ${
                  currentPage === 0 ? "disabled" : ""
                }`}
                onClick={() => currentPage > 0 && setCurrentPage(currentPage - 1)}
              >
                Prev
              </Link>
              {Array.from({ length: totalPages }, (_, i) => (
                <Link
                  key={i}
                  className={`btn btn-sm border ${
                    currentPage === i ? "btn-primary text-white" : ""
                  }`}
                  onClick={() => setCurrentPage(i)}
                >
                  {i + 1}
                </Link>
              ))}
              <Link
                className={`btn btn-sm btn-outline-primary ms-2 ${
                  currentPage === totalPages - 1 ? "disabled" : ""
                }`}
                onClick={() =>
                  currentPage + 1 < totalPages && setCurrentPage(currentPage + 1)
                }
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChairliftDB

